export const GET_SOURCES = "GET_SOURCES";
export const ADD_SOURCE = "ADD_SOURCE";
export const EDIT_SOURCE = "EDIT_SOURCE";
export const GET_SOURCE = "GET_SOURCE";
export const RESET_SOURCE = "RESET_SOURCE";
export const ERROR_SOURCE = "ERROR_SOURCE";
export const GET_ALL_SOURCES = "GET_ALL_SOURCES";
                                    